var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.442,
    height: 20.441,
    viewBox: "0 0 36.442 36.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8305",
    "data-name": "Group 8305",
    transform: "translate(15943.703 19316.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16073",
    "data-name": "Path 16073",
    d: "M1033.263,42.229A18.222,18.222,0,1,1,1051.558,24.1a18.231,18.231,0,0,1-18.295,18.128M1043.7,24h.04c0-1.464.042-2.929-.008-4.391-.118-3.385-1.948-5.628-5.307-5.885a68.993,68.993,0,0,0-10.149-.008c-3.2.228-5,2.031-5.23,5.222a70.887,70.887,0,0,0,0,10.15c.232,3.191,2.038,4.983,5.238,5.213a71.505,71.505,0,0,0,10.07.006c3.227-.225,4.988-2.132,5.313-5.353.165-1.636.029-3.3.029-4.956",
    transform: "translate(-16958.818 -19322.59)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16074",
    "data-name": "Path 16074",
    d: "M1056.369,36.662c0,1.653.136,3.319-.029,4.955-.325,3.221-2.086,5.128-5.314,5.353a71.5,71.5,0,0,1-10.07-.006c-3.2-.23-5.007-2.023-5.238-5.213a70.807,70.807,0,0,1,0-10.15c.228-3.191,2.034-4.995,5.229-5.223a69.1,69.1,0,0,1,10.149.008c3.359.258,5.189,2.5,5.307,5.886.051,1.462.009,2.927.009,4.39h-.04m-10.288-8.489v-.005c-1.517,0-3.037-.063-4.551.014-2.549.131-3.924,1.449-4,3.983q-.141,4.506,0,9.019a3.678,3.678,0,0,0,3.932,3.958c3.031.1,6.07.1,9.1,0a3.666,3.666,0,0,0,3.914-3.889c.1-3.058.1-6.123,0-9.181-.08-2.437-1.464-3.749-3.925-3.884-1.485-.082-2.979-.015-4.469-.015",
    transform: "translate(-16971.488 -19335.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16075",
    "data-name": "Path 16075",
    d: "M1049.224,31.36c1.49,0,2.983-.067,4.469.015,2.46.135,3.844,1.447,3.924,3.884.1,3.058.1,6.123,0,9.181a3.666,3.666,0,0,1-3.914,3.889q-4.546.145-9.1,0a3.678,3.678,0,0,1-3.933-3.958q-.141-4.506,0-9.019c.079-2.535,1.454-3.853,4-3.983,1.513-.078,3.033-.014,4.55-.014v.005m-.051,13.857a5.36,5.36,0,1,0-5.385-5.356,5.344,5.344,0,0,0,5.385,5.356m5.573-9.7a1.243,1.243,0,1,0-1.255-1.229,1.265,1.265,0,0,0,1.255,1.229",
    transform: "translate(-16974.631 -19338.438)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16076",
    "data-name": "Path 16076",
    d: "M1054.385,50.391a5.36,5.36,0,1,1,5.335-5.406,5.343,5.343,0,0,1-5.335,5.406m3.455-5.375a3.48,3.48,0,1,0-3.506,3.494,3.469,3.469,0,0,0,3.506-3.494",
    transform: "translate(-16979.844 -19343.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16077",
    "data-name": "Path 16077",
    d: "M1075.818,38.289a1.243,1.243,0,0,1-.027-2.486,1.243,1.243,0,1,1,.027,2.486",
    transform: "translate(-16995.703 -19341.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16078",
    "data-name": "Path 16078",
    d: "M1060.914,48.089a3.48,3.48,0,1,1-3.453-3.466,3.471,3.471,0,0,1,3.453,3.466",
    transform: "translate(-16982.916 -19346.686)",
    fill: "#5aa2fb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.19a63c8622e0846201085069d680b483.svg";
export { ForwardRef as ReactComponent };